module.exports = __webpack_public_path__ + "static/img/304.da678f9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kittens/190926/304.jpg
// module id = E3P6
// module chunks = 0